export default {
  title: { //各頁面標題 路由 index 內
    home: '首頁',
    sec_kill: '限時購',
    product_list: '產品列表',
    search: '鉆石搜索',
    search_item: '鉆石搜索',
    product_detail: '鉆石詳情',
    share_with_money: '分享領現金',
    share_page: '分享領現金',
    share_get_page: '分享領現金',
    ssh: '搜飾盒',
    download_page: 'APP下載',
    share_img: '搜飾盒分享',
    fang_jia_tong_zhi: '搜飾盒放假通知',
  },
  // 頁面文案
  home: {},
  order: {
    help: {
      title: '需要幫助嗎？',
      text: '您可以通過以下方式聯繫我們：',
      link: {
        title: '客服熱線',
        tel_1: '(852) 2508-0998',
        tel_2: '(86) 0755-2590-1884',
        rank: '(週壹至週日：9 : 30AM - 8 : 00PM',
      },
      email: {
        title: '官方郵箱',
        text: 'info@jewellery-box.com'
      },
      promise: {
        title: '搜飾盒購物承諾',
        title_1: '包郵政策',
        text_1: '購物消費滿$1500即可享受包郵服務',
        title_2: '7天無理由退換',
        text_2: '搜飾盒承諾所有商品享受七天無理由 退換貨',

      }
    },
    confirm: {
      title: '確認訂單',
      md_text: '門店自提',
      zr_text: '寄送上門',
      receive_info: {
        title: '取貨人信息',
      },
      address: {
        title: '送貨地址',
        add: '新增地址'
      },
      order_detail: {
        title: '訂單明細',
        sum: '小計',
        ship: '配送',
        total: '總價',
      },
      button: {
        back: '繼續購物',
        submit: '提交訂單',
      }
    }
  },
  form: {
    name: '姓名',
    first_name: '姓氏',
    last_name: '名字',
    email: '郵箱',
    area_code: '區號',
    phone: '電話',
    validator: {
      name: '請填寫姓名',
      first_name: '請填寫姓氏',
      last_name: '請填寫名字',
      email: '請填寫郵箱地址',
      area_code: '請選擇區號',
      phone: '請填寫電話',
      address: '請選擇地區並填寫詳細地址',
    },
    placeholders: {
      email: '*郵箱地址',
      phone: '*電話號碼',
      address: '請填寫詳細地址',
    }
  },
  // 其他
  exchange_support: '支持無限換戴',
  share_img_button: '長按圖片保存至手機',
  token_required: '請先登陸',
  token_expire: '登陸或已過期，請重新登陸',
  price_sign: '￥',
  price_text: '售價',
  empty: '沒有更多了',
  loosing: '釋放即可刷新...',
  loading: '加載中...',
  reload: {
    success: '刷新成功',
    failed: '刷新失敗',
  },

//  todo 英文版翻译
  mall_home: {
    location: '香港特別行政區',
    my_account: '我的賬戶',
    account_num: '賬號',
    logout: '退出登錄',
    please: '請先',
    login: '登錄',
    register: '註冊',
    infor: '個人信息',
    my_order: '我的訂單',
    my_wishlist: '我的購物車',
    jewellery_box: '搜飾盒',
    fine_jewellery: '珠寶首飾',
    brand: '品牌世界',
    about_us: '我們的品牌',
    about_exchange: '無限換戴',
    about_vip: '尊享體驗',
    about_boss: '強大股東領航',
    about_honor: '企業榮譽',
    about_history: '發展歷程',
    about_join_us: '招募合夥人',
    download: 'app下載',
    hot: '搜饰红人',
    gia: '鑽石定制',
    jewellery_type: '類別',
    jewellery_collect: '系列',
    brand_type: '類別',
    new_collection: '全新系列',
    exchange: '搜飾盒珠寶無限換戴',
    find_store: '前往附近的體驗中心',
    explore_products: '更多體驗等妳來',
    total: '總金額',
    view_cart: '查看購物袋',
    chose: '已選',
    items: '件',
    shop: '立即選購',
    all: '查看所有',
    all_product: '綜合篩選',
    rg: '戒指',
    bg: '手鐲',
    er: '耳環',
    bl: '手鏈',
    pd: '吊墜',
    nl: '項鏈',
    cl: '男士珠寶',
    w_ring: '婚戒&对戒',
    mens: '男士珠寶',
    search_series_type:'搜索 系列/類別/款號',
    company:'© 傳承科技有限公司 2020 .版權所有'
  },
  mall_detail: {
    color: '顏色',
    size: '尺寸',
    params: '商品參數',
    add_cart: '加入購物袋',
    to_buy: '立即購買',
    you_like: '推薦搭配',
    my_cart: '我的購物袋',
    have: '共',
    items: '件商品',
    total: '總計',
    checkout: '結算購物車',
    free_size: '均碼',
    free_num: '號',
    choose_size: '請選擇尺寸',
    success_add: '添加成功',
    select_color: '未選擇顏色',
    select_size: '未選擇尺寸',
    cart_empty:'當前購物車為空'
  },
  mall_search: {
    sort_by: '排序方式',
    low_2_high: '價格從低至高',
    high_2_low: '價格從高至低',
    new: '新品',
    buy: '立即購買',
    loading: '加載中...',
    no_more: '沒有更多了',
    collected:'已收藏',
    collection_cancel:'已取消收藏'
  },
  mall_login: {
    phone_login: '手機登錄',
    area_num: '區號',
    input_phone: '請輸入手機號',
    input_code: '請輸入圖形驗證碼',
    phone_pwd: '手機驗證碼',
    input_phone_pwd: '請輸入6位手機驗證碼',
    code_resend: '沒收到驗證碼？重新發送',
    success: '成功',
    message_has_sent: '短信驗證碼已發送',
    error: '錯誤',
    error_phone: '手機號碼有誤，請重填',
    error_phone_pwd: '請填寫正確的手機驗證碼',
    success_login: '登錄成功',

  },
  mall_self_page: {
    appellation: '稱謂',
    man: '先生',
    woman: '女士',
    first_name: '姓',
    input_first_name: '請輸入您的姓氏',
    last_name: '名',
    input_last_name: '請輸入您的名字',
    birthday: '生日',
    select_date: '選擇日期',
    email: '电子邮箱',
    input_email: '請輸入您的邮箱地址',
    cancel: '放棄修改',
    save: '保存',
    input_birth: '請填寫生日',
    success_changed: '修改成功'//Successfully changed
  },
  mall_profile: {
    my_account: '我的賬戶',
    welcome: '歡迎回來',
    user_infor: '個人信息',
    my_order: '我的訂單',
    my_cart: '我的購物袋',
  },
  mall_order: {
    all_order: '全部訂單',
    have: '共',
    items_order: '筆訂單',
    items_product: '件商品',
    no_more_tips: '您還沒有訂單，快去挑選心儀的首飾',
    pay: '立即支付',
    cancel: '取消訂單',
    shop: '去選購商品',
    including_postage: '含郵費',
    order_cancel: '成功取消訂單',
  },
  mall_cart: {
    total: '合計',
    pay: '結算',
    no_more: '您的購物車暫無商品',
    go_shop: '去選購商品',
    success_delete: '刪除成功',
    cart_none: '購物車為空',
  },
  mall_download: {
    bring_moment: '為您帶來更多精彩瞬間'
  },
  mall_bottom:{
    promise:{
      icon_1:'資深廠商直供',
      icon_2:'87項檢測入庫',
      icon_3:'100%正品',
      icon_4:'假一賠三',
      icon_5:'支持無限換戴',
      icon_6:'支持升級換戴',
    },
    about_me:{
      title:'關於我們',
      about_us: '我們的品牌',
      about_honor: '企業榮譽',
      about_history: '發展歷程',
      about_join_us: '招募合夥人',

    },
    guide:{
      title:'購物指南',
      buy_way:'購買流程',
      pay_way:'支付方式',
      store_way:'門市地址',
      about_exchange: '無限換戴',
    },
    service:{
      title:'服務中心',
      rule_acceptance:'驗收標準及賠償規則',
      rule_exchange:'換戴政策',
      rule_user:'用戶協議',
      rule_privacy:'隱私政策'
    },
    download:'下載應用',
    contact_us:'聯繫我們',
    follow_us:'關注我們',
  },
  mall_order_detail:{
    order_detail:'訂單詳情',
    order_num:'訂單編號',
    receiver:'收件人',
    phone_num:'收件號碼',
    address:'配送地址',
    total:'總價',
    pay:'立即支付',
    cancel:'取消訂單',
    service:'如需退款/退貨，請聯繫客服'
  },
  mall_pay_success:{
    pay_success:'支付成功！',
    tips:'搜飾盒正在為您準備首飾',
    view_order:'查看訂單'
  },
  mall_confirm_order:{
    md:'門店自取',
    md_tips:'（費用全免·尊貴體驗）',
    zt:'預約自取',
    zt_tips:'（辦公室、港鐵站）',
    receiver:'取貨人信息',
    surname:'姓氏',
    input_surname:'請填寫姓氏',
    given_name:'名字',
    input_name:'請填寫名字',
    email:'郵箱',
    input_email:'*請輸入郵箱地址',
    phone:'電話',
    input_phone:'*請輸入電話號碼',
    zt_address:'*請填寫交收的辦公地點/港鐵站點',
    ship_way:'送貨地址',
    add_address:'新增地址',
    order_detail:'訂單明細',
    subtotal:'小計',
    shipping:'配送',
    user_coupon:'優惠券使用',
    input_code:'輸入優惠碼',
    submit:'提交',
    remarks:'訂單備註',
    input_remarks:'請寫下您對特殊要求，限50個字哦～',
    total:'總價',
    support:'支持',
    continue_shopping:'繼續購物',
    submit_order:'提交訂單',
    cheap:'優惠減免',
    address_tips:'請先 完成/取消 當前的地址編輯',
    tips:'提示',
    true_del:'確認刪除嗎?',
    create_order:'創建訂單成功',
    input_md:'請選擇壹個門店',
    input_zr:'請選擇壹個收貨地址',
    input_zj:'請填寫交收地點'
  },
  mall_order_index:{
    order_confirmation:'確認訂單',
    pay_order:'支付訂單',
    pay_success: '支付成功',
    need_help:'需要幫助嗎？',
    contact_us:'您可以通過以下方式聯繫我們：',
    cs_hotline:'客服熱線',
    work_day:'客服工作日:',
    mon_sun:'逢星期一至星期五 早上10點到下午6點',
    office_email:'官方郵箱',
    shopping_promise:'搜飾盒購物承諾',
    policy:'配送政策',
    policy_content:'產品準備好後，客戶服務人員聯繫您預約時間，免費到香港各地（除離島外）辦公室及各港鐵站進行交收',
    free_exchange: '無限次數換戴',
    exchange_content:'凡在搜飾盒購買鑲嵌鑽石產品，即可成為搜飾盒會員，享有會員無限次數換戴服務。全新珠寶，等價換戴',
    tips:'*須受有關條款及細則約束，詳情請查看搜飾盒App，或向客戶服務人員聯絡。',
  },
  mall_pay_order:{
    payment_method:'請選擇您期望的支付方式',
    credit_card:'信用卡號',
    valid_term:'有效期',
    input_credit_card:'請輸入妳本人點信用卡號',
    input_cvs:'請輸入卡背後簽名處3位數字',
    input_phone_num:'請填寫電話',
    error_month:'信用卡過期年份錯誤',
    error_year:'信用卡過期年份錯誤',
    error_cvn:'請輸入正確的CVN號碼',
    confirm_infor:'請確認支付信息',
    no_more:'當前沒有待支付訂單',
    tips:'提示',
    sure:'確定',
    pay_fail:'支付失敗，請檢查支付信息是否正確',
  },
  mall_gia_search:{
    gia_diamond:'GIA鑽石',
    certificate:'證書',
    certificate_num:'證書編號',
    search_certificate_num:'搜索證書編號',
    hk:'香港',//HongKong
    foreign:'海外',//Foreign
    reset:'重置',
    search:'搜索',
    loading:'拼命加載中...',
    no_more:'對不起，沒有查詢到您想要的商品，請 聯系客服 或者重新選擇哦！',
    carat:'鑽重',
    shape:'形狀',
    color:'顏色',
    clarity:'凈度',
    cut:'切工',
    polish:'拋光',
    symmetry:'對稱',
    fluorescent:'熒光',
    location:'所在地',
    price:'價格',
    option:'操作',
    check:'立即查看',
    have:'共',
    items:'條'
  },
  mall_gia_detail:{
    diamond: '鑽石',
    params:'鑽石參數',
    gia_cer:'GIA證書',
    contact_us:'在線咨詢',
    custom_process:'定制流程',
  }

}



// WEBPACK FOOTER //
// ./src/lang/hk.js